module.exports = __webpack_public_path__ + "img/trail.629ec14a.svg";